import { createFileRoute } from '@tanstack/react-router';

type ThreadCreationSearch = {
  personPhone?: string;
  personId?: string;
  locationPhone?: string;
  locationId?: string;
};

export const Route = createFileRoute('/messages/$filter/new')({
  validateSearch: (search: Partial<ThreadCreationSearch>): ThreadCreationSearch => {
    return {
      personPhone: search.personPhone,
      personId: search.personId,
      locationPhone: search.locationPhone,
      locationId: search.locationId,
    };
  },
});
